"use client";
import React, { useState } from "react";

export const dynamic = "force-dynamic";

const EnterpriseTechnologies = () => {
  const [Data, setData] = useState(1);
  const [Active, setActive] = useState(1);
  const Warehousing = (e, id) => {
    e.preventDefault();
    setData(id);
    setActive(id);
  };
  return (
    <>
      <div className=" mx-auto py-10 xl:px-20 md:mt-[140px] mt-10 bg-[#F6F3FB] md:px-24">
        <div className="font-bold leading-5 lg:leading-[65px] text-center xl:text-[45px] lg:text-[40px] md:text-[25px] text-[20px] py-5">
          <div className="font-bold leading-5 lg:leading-[65px] text-center xl:text-[45px] lg:text-[40px] md:text-[25px] text-[20px] py-5">
            Enterprise
            <span className="text-[#410EAD] ">
              Technologies We Use
            </span>
          </div>
          <p className="  gap-5  xl:px-40 pt-10 text-[#59587C]  leading-5 text-[17px] font-normal py-5">
            Tan <span className="font-manrope">θ</span> is one of the fastest growing enterprise application software
            development companies with a wide ranging experience in all the
            cutting edge technologies including Blockchain, Internet of Things
            (IoT), Artificial Intelligence (AI), Cloud Computing, Data Science &
            Analytics, and Augmented & Virtual Reality (AR/VR). Languages
          </p>
          <div className="">
            <div className=" flex  flex-wrap gap-3  justify-center py-5">
              <button
                className={
                  Active === 1
                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 1);
                }}
              >
                Languages
              </button>
              <button
                className={
                  Active === 2
                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 2);
                }}
              >
                Frameworks
              </button>
              <button
                className={
                  Active === 3
                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 3);
                }}
              >
                Mobile
              </button>
              <button
                className={
                  Active === 4
                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 4);
                }}
              >
                Web
              </button>
              <button
                className={
                  Active === 5
                    ? " bg-[#410EAD]  border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 5);
                }}
              >
                Database Management
              </button>
              <button
                className={
                  Active === 6
                    ? " bg-[#410EAD] border-[#410EAD] text-sm lg:text-lg font-normal text-white rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700"
                    : "text-sm lg:text-lg font-normal bg-white hover:bg-[#410EAD] text-410EAD hover:text-white border border-[#410EAD]  rounded-[20px] shadow-[#410eadb3] shadow-sm hover:shadow-md px-5 md:px-3 py-1 ease-in-out duration-700 "
                }
                onClick={(e) => {
                  Warehousing(e, 6);
                }}
              >
                Cloud
              </button>
            </div>
            {Data === 1 ? (
              <div className="flex justify-center flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>Java</p>
                <p>C#</p>
                <p>Objective C</p>
                <p>Scala</p>
                <p>Swift</p>
              </div>
            ) : null}
            {Data === 2 ? (
              <div className="flex justify-center flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>react</p>
                <p>node</p>
                <p>Objective C</p>
                <p>Scala</p>
                <p>Swift</p>
              </div>
            ) : null}
            {Data === 3 ? (
              <div className="flex justify-center flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>Java</p>
                <p>Kotlin</p>
                <p>Python</p>
                <p>Dart </p>
                <p>JavaScript</p>
              </div>
            ) : null}
            {Data === 4 ? (
              <div className="flex justify-center  flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>Java </p>
                <p>React js</p>
                <p>PHP</p>
                <p>.NET</p>
                <p>HTML</p>
              </div>
            ) : null}
            {Data === 5 ? (
              <div className="flex justify-center  flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>Microsoft SQL Server</p>
                <p>Postgre SQL.</p>
                <p>My SQL.</p>
                <p>Amazon RDS.</p>
                <p>SQLite</p>
              </div>
            ) : null}
            {Data === 6 ? (
              <div className="flex justify-center  flex-wrap text-base leading-8 px-30 text-center  gap-10">
                <p>Java </p>
                <p>Python</p>
                <p>Golang</p>
                <p>Ruby</p>
                <p>JavaScript</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default EnterpriseTechnologies;
